
import React from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import ArticleLink from '../articles/ArticleLink';
import TileContent from './TileContent';

const classNames = mergeStyleSets({
    bold: {
        fontWeight: 'bold',
        fontSize: '16px'
    }
});

const TileHonitbaKey = () => {
    return (
        <TileContent title="Honitba na klíč">
            <Stack tokens={{childrenGap: 16}}>
                <Stack>
                    <Stack.Item>- Jsou vlastnické vztahy ve vaší honitbě komplikované? </Stack.Item>
                    <Stack.Item>- Nemáte čas řešit problémy s evidencí honebních parcel nebo s přípravou valné hromady?</Stack.Item>
                    <Stack.Item>- Chcete mít zpracovány podklady na profesionální úrovni?</Stack.Item>
                </Stack>
                <Stack.Item align="center" className={classNames.bold}>
                    <>Využijte Honitbu na klíč!</>
                </Stack.Item>
                <Stack.Item align="center">
                    <>Podrobnosti najdete v článku </>
                    <ArticleLink name="honitba_na_klic" title="Honitba na klíč"/>
                </Stack.Item>
            </Stack>
        </TileContent>
    );
}

export default TileHonitbaKey;
